<form [formGroup]="form">
  <div class="condition-rule">
    <table>
      <tbody>
      <tr>
        <td>
          <label>Question</label>
          <app-input-select controlName="elementId" [items]="elementOptions" [parentForm]="form"></app-input-select>
        </td>
        <td>
          <label>Operator</label>
          <app-input-select controlName="operator" [items]="operatorOptions" [parentForm]="form"></app-input-select>
        </td>
        <td>
          <label>Value</label>
          <app-input-select controlName="value" [items]="valueOptions" [parentForm]="form"></app-input-select>
        </td>
        <td class="buttons"><app-button text="Remove" size="sm" variant="info" type="button" (click)="removeCondition()" /></td>
      </tr>
      </tbody>
    </table>
  </div>
</form>
